import * as React from 'react';
import * as styles from './style.css';
import { UIText1 } from '@cian/ui-kit';
import { IAwardsSource } from '../../types/developerV2/awards';

interface ISourcesProps {
  sources: IAwardsSource[];
}

export const AwardsSources = ({ sources }: ISourcesProps) => {
  const forbsUrl = React.useMemo(() => {
    return sources.find(source => source.type === 'forbes')?.url;
  }, [sources]);

  const uawardsUrl = React.useMemo(() => {
    return sources.find(source => source.type === 'uawards')?.url;
  }, [sources]);

  return (
    <UIText1>
      Все награды можно посмотреть на&nbsp;сайте{' '}
      <a href={uawardsUrl} target="_blank" rel="noreferrer" className={styles['source-link']}>
        Urban Awards
      </a>{' '}
      и{' '}
      <a href={forbsUrl} target="_blank" rel="noreferrer" className={styles['source-link']}>
        Forbes
      </a>
    </UIText1>
  );
};
